import React from "react";

const CommonFooter = () => {
  return (
    <div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">{new Date().getFullYear()} © Style Buzz Pro. All Right Reserved</p>
        <p>Designed &amp; Developed by Style Buzz Pro</p>
      </div>
    </div>
  );
};

export default CommonFooter;
